import React, { useState } from "react";
import {
  StyledActualProjectBody,
  StyledWorkInformationBodyGrid,
} from "../Resume.styled";
import { InfoContainer } from "../../../../../components/core/InfoContainer/InfoContainer";
import { BodyTyp } from "../../../../../components/Typography/Typography";
import { FontWeightEnum, IconSizeEnum } from "../../../../../types/AppTypes";
import { ACTUAL_PROJECT_LABEL } from "../../../../../constants/Dictionary";
import { IconManager } from "../../../../../components/core/IconManager/IconManager";
import { CollaboratorResume } from "../../../../../types/api/collaborators.type";
import { ReactComponent as ProjectIcon } from "../../../../../icons/project.svg";
import {
  Accordion,
  AccordionVariantEnum,
} from "../../../../../components/core/Accordion/Accordion";

export const ActualProject = ({
  data,
}: {
  data: CollaboratorResume | null;
}) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(true);

  return (
    <div className="page-break">
      <Accordion
        label={
          <BodyTyp variant="2" fontWeight={FontWeightEnum.SEMIBOLD}>
            {ACTUAL_PROJECT_LABEL}
          </BodyTyp>
        }
        variant={AccordionVariantEnum.SECONDARY}
        leftComponent={
          <IconManager size={IconSizeEnum.SMALL}>
            <ProjectIcon />
          </IconManager>
        }
        onToggle={setIsAccordionOpen}
        isOpen={isAccordionOpen}
      >
        <StyledWorkInformationBodyGrid>
          {data?.currentProjects.map((el, idx) => (
            <InfoContainer key={`${idx}${el}`} variant="1">
              <StyledActualProjectBody>
                <BodyTyp variant="2" fontWeight={FontWeightEnum.MEDIUM}>
                  {el}
                </BodyTyp>
              </StyledActualProjectBody>
            </InfoContainer>
          ))}
        </StyledWorkInformationBodyGrid>
      </Accordion>
    </div>
  );
};
